import React from "react";
import cx from "classnames";
import ImageElement from "../ImageElement/ImageElement.jsx";
import FindOfficeForm from "../FindOfficeForm/FindOfficeForm.jsx";

const FindOfficeBanner = props => {
  const {
    title,
    text,
    icon,
    address,
    city,
    submitLabel,
    stateSelect,
    distanceSelect,
    label,
    defaultCity,
    defaultState,
    defaultDistance,
    defaultMarket,
    agentTypes,
    isResultsOnly,
  } = props;

  const renderIcon = () => {
    if (!icon) return null;
    if (typeof icon === "string" && /(fa[srldb]?|fa-)/.test(icon))
      return (
        <i className={`find-office-banner__icon ${icon}`} aria-hidden="true" />
      );

    if (typeof icon === "string" && !/(fa[srldb]?|fa-)/.test(icon)) {
      return (
        <img
          className="find-office-banner__icon"
          src={icon}
          alt=""
          aria-hidden="true"
        />
      );
    }
    return null;
  };

  return (
    <section className={cx("find-office-banner js-dynamic-banner")}>
      <div className="find-office-banner__content">
        <div className="find-office-banner__content-inner find-office-banner__two-col">
          <div
            className="find-office-banner__main"
            style={{ display: isResultsOnly ? "none" : "block" }}
          >
            <div className="find-office-banner__title-row">
              {renderIcon()}
              {title && <h2 className="find-office-banner__title">{title}</h2>}
            </div>

            {text && (
              <div
                className="find-office-banner__text"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>

          <aside className="find-office-banner__aside">
            <FindOfficeForm
              label={label}
              address={address}
              city={city}
              stateSelect={stateSelect}
              distanceSelect={distanceSelect}
              submitLabel={submitLabel}
              defaultCity={defaultCity}
              defaultState={defaultState}
              defaultDistance={defaultDistance}
              defaultMarket={defaultMarket}
              agentTypes={agentTypes}
              isResultsOnly={isResultsOnly}
            />
          </aside>
        </div>
      </div>
    </section>
  );
};

export default FindOfficeBanner;
